import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubHookFormSelect } from "../../components";
import BarcodeValueTable from "./BarcodeValueTable";

export const BarcodeValue = ({ disabled = false }) => {
  const bools = [
    { id: 0, label: "False" },
    { id: 1, label: "True" },
  ];

  return (
    <Stack width="100%" gap="5px">
      <Typography variant="boldCaptionMain">Barcode Value</Typography>
      <Stack width="100%" gap="15px">
        <BarcodeValueTable />
        <Stack direction="row" gap="5px">
          <HubHookFormSelect
            name="delimiter"
            label="Delimiter"
            options={["-", "/", "_", "Space"]}
            disabled={disabled}
            required
          />
          <HubHookFormSelect
            name="serialize"
            label="Serialize"
            options={bools}
            disabled={disabled}
            useDefault
            required
          />
          <HubHookFormSelect
            name="label"
            label="Include Label"
            options={bools}
            disabled={disabled}
            useDefault
            required
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BarcodeValue;
